<template>
  <div>
    <h4>Запись будет скрыта по причине отсутствия поставщика</h4>
    <div class="input-group">
      <label>
        <input type="checkbox" v-model="addDelay"> активировать запись через некоторое время
      </label>
    </div>
    <div>
      <template v-if="!addDelay">
        <textarea v-model="comment" class="form-control" placeholder="Комментарий" rows="2"/>
      </template>
      <template v-else>
        <ShiftTaskActualDate ref="ShiftTaskActualDate" plusDays="60"/>
      </template>
    </div>
  </div>
</template>
<script>
import ShiftTaskActualDate from "@/views/statistics/components/ShiftTaskActualDate.vue";
import api from "@/api";

export default {
  components: {ShiftTaskActualDate},
  props: ['data'],
  data() {
    return {
      addDelay: false,
      comment: '',
    }
  },
  methods: {
    async updateRecord() {
      const {data} = await api.post('/statistics/003/codes', {
        action: 'updateStatus',
        status_type: 'no_supplier_found',
        status: this.addDelay ? 'delayed' : null,
        data: {comment: this.comment, shiftData: this.$refs.ShiftTaskActualDate?.getData()},
        drug_id: this.data.record?.drug_id,
      })
      if (data.success) {
        toastr['success']('Сохранено!');
        return true;
      } else {
        toastr['warning'](data.message ?? 'ошибка сервера', 'Ошибка');
      }
      return false;
    }
  }
}
</script>
